import AccessTimeIcon from "@mui/icons-material/AccessTime";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type DateRangeBadgePeriod =
  "yesterday" | "today" | "week_to_date" | "last_weekend" | "last_4_weeks" | "custom";

interface UseDateRangeBadgeOptions {
  period: DateRangeBadgePeriod;
  freshnessText?: string;
}

interface DateRangeBadgeConfig {
  freshnessFooterText?: string;
  freshnessFooterTooltip?: string;
  freshnessFooterIcon?: ReactNode;
}

export const useDateRangeBadge = ({
  period,
  freshnessText,
}: UseDateRangeBadgeOptions): DateRangeBadgeConfig => {
  const { t } = useTranslation();

  return {
    ...(period === "today" && {
      freshnessFooterText: freshnessText ?? t("common.datePeriodToggle.text.updatesEvery30Minutes"),
      freshnessFooterTooltip: t("common.datePeriodToggle.tooltips.liveDataFreshness"),
      freshnessFooterIcon: <AccessTimeIcon sx={{ fontSize: 14 }} />,
    }),
  };
};
